import { InputConfig } from "@cpj-ai/panel-npm-package";
import { AuthAccountOrganizationJobPositionStatusChoices } from "@graphql/generated";

export interface IFormData {
  title?: string;
  status?: { label: string; value: AuthAccountOrganizationJobPositionStatusChoices & "all" };
  date?: Date[];
}

export const inputConfigs: InputConfig[] = [
  {
    name: "title",
    previewSize: {
      sm: 12,
      md: 6,
      lg: 4,
    },
    inputProps: {
      type: "text",
      label: "Job Title",
      placeholder: "Enter job title",
    },
  },
  {
    name: "status",
    previewSize: {
      sm: 12,
      md: 6,
      lg: 4,
    },
    inputProps: {
      type: "searcher",
      label: "Job Status",
      placeholder: "Select job status",
      labelKey: "label",
      valueKey: "value",
      items: [
        { value: "all", label: "All" },
        { value: AuthAccountOrganizationJobPositionStatusChoices.PUBLISHED, label: "Open" },
        { value: AuthAccountOrganizationJobPositionStatusChoices.SUSPENDED, label: "Suspend" },
        { value: AuthAccountOrganizationJobPositionStatusChoices.REJECTED, label: "Rejected" },
        { value: AuthAccountOrganizationJobPositionStatusChoices.EXPIRED, label: "Close" },
        { value: AuthAccountOrganizationJobPositionStatusChoices.SUBMITTED, label: "Submitted" },
        { value: AuthAccountOrganizationJobPositionStatusChoices.CAPACITY_FILLED, label: "Capacity Filled" },
        { value: AuthAccountOrganizationJobPositionStatusChoices.DRAFTED, label: "Drafted" },
      ],
    },
  },
  {
    name: "date",
    previewSize: {
      sm: 12,
      md: 12,
      lg: 4,
    },
    inputProps: {
      type: "date",
      label: "Job Start Date",
      placeholder: "Select Job Start date",
      range: true,
    },
  },
];
